export default __webpack_public_path__ + "static/media/mobileRespPhoto.b4c849d3.svg";